<template>
  <transition-group name="fade" tag="div" class="overlay-loader" @after-leave="afterLeave">
    <div v-for="component in visibleComponents" :key="`overlay-${component.id}`">
      <keep-alive>
        <component :is="component.is" v-bind="component.props" />
      </keep-alive>
    </div>
  </transition-group>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import overlayStore, { URL_PARAMS_TO_SHOW_OVERLAYS } from '@/stores/overlay'
import { toggleDocumentOverflow } from '@/helpers/scroll'
import { registerStores } from '@/helpers/stores'
import { getQueryFromUrl } from '@/helpers/url'

export default {
  name: 'OverlayLoader',

  data() {
    return {
      hasLastVisibleOverlayFadingOut: false,
    }
  },

  computed: {
    ...mapGetters({
      visibleComponents: 'overlay/visibleComponents',
      hasVisibleOverlays: 'overlay/hasVisibleOverlays',
    }),
  },

  watch: {
    hasVisibleOverlays(value) {
      this.hasLastVisibleOverlayFadingOut = !value
      if (value) toggleDocumentOverflow(false)
    },
  },

  beforeCreate() {
    registerStores({ overlay: overlayStore })
  },

  mounted() {
    this.showOverlaysBasedOnUrlParams()
  },

  methods: {
    ...mapActions({
      preloadOverlay: 'overlay/preload',
      showOverlay: 'overlay/show',
    }),

    afterLeave() {
      if (this.hasLastVisibleOverlayFadingOut) {
        toggleDocumentOverflow(true)
        this.hasLastVisibleOverlayFadingOut = false
      }
    },

    async showOverlaysBasedOnUrlParams() {
      for (const id in URL_PARAMS_TO_SHOW_OVERLAYS) {
        if (getQueryFromUrl(URL_PARAMS_TO_SHOW_OVERLAYS[id])) {
          const delay = Number(getQueryFromUrl('delay'))
          const preloadPromise = this.preloadOverlay(id)
          const show = async () => {
            await preloadPromise
            await this.$nextTick()
            this.showOverlay(id)
          }
          delay ? setTimeout(show, delay * 1000) : show()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.overlay-loader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: $navigation-z-index + 1;
}

.fade-enter-active,
/deep/ .overlay__body {
  transition: opacity ease-in-out;
}

.fade-leave-active,
/deep/ .overlay__body {
  transition: opacity ease;
}

.fade-enter-active {
  transition-duration: $transition-time-fast;

  /deep/ .overlay__body {
    transition-duration: $transition-time;
    transition-delay: $transition-time-fast;
  }
}

.fade-leave-active {
  transition-duration: $transition-time-medium;
  transition-delay: 100ms;

  /deep/ .overlay__body {
    transition-duration: $transition-time;
  }
}

.fade-enter,
.fade-leave-to {
  opacity: 0;

  /deep/ .overlay__body {
    opacity: 0;
  }
}
</style>
